module.exports = __webpack_public_path__ + "media/images/icon_list/list_dot-ee4bf0fc353da98e5bace37ab80cd61c.svg";